module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"work_count":"Work count","all":"All institutions","inst_filter":"Owner institution filter"},"cs":{"work_count":"Počet děl","all":"Všechny instituce","inst_filter":"Filtr podle instituce"}}')
  delete Component.options._Ctor
}
